import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip'; // For the full text tooltip
import { CustomContextMenuItem } from '../custom-context-menu/custom-context-menu.component';
import { ContextMenuSelection, CustomContextMenuService } from '../custom-context-menu/custom-context-menu.service';

@Component({
  selector: 'app-interactive-list-item',
  templateUrl: './interactive-list-item.component.html',
  styleUrls: ['./interactive-list-item.component.scss'],
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InteractiveListItemComponent {
  @Input() itemText: string = '';
  @Input() itemIcon?: string;
  @Input() isSvgIcon: boolean = false;
  @Input() data?: any;
  @Input() badge?: string | number;
  @Input() buttons?: CustomContextMenuItem[] = [];
  @Input() disabled: boolean = false;

  @Output() itemClicked = new EventEmitter<any>();
  @Output() contextAction = new EventEmitter<{ actionId: string; data?: any }>();

  @ViewChild('textElement') textElementRef!: ElementRef<HTMLElement>;

  private contextMenuService = inject(CustomContextMenuService);

  onItemClick(): void {
    this.itemClicked.emit(this.data);
  }

  onOptionsClick(event: MouseEvent, triggerElement: MatIconButton): void {
    event.stopPropagation();
    if (triggerElement && triggerElement._elementRef) {
      this.contextMenuService.open(triggerElement._elementRef, this.buttons, this.data).subscribe((selection: ContextMenuSelection) => {
        if (selection) {
          this.handleContextMenuItemSelection(selection);
        }
      });
    }
  }

  private handleContextMenuItemSelection(selection: ContextMenuSelection): void {
    this.contextAction.emit({ actionId: selection.actionId, data: selection.data });
  }
}
